import '../styles/main.scss';
import Util from './modules/Utilities';
import smoothscroll from 'smoothscroll-polyfill';
import Menu from './modules/Menu';
import ScrollEvent from './modules/ScrollEvents';
import Tabs from './modules/Tabs';
import Sliders from './modules/Sliders';
import Animation from './modules/Animation';
import Lazyload from './modules/Lazyload';

document.addEventListener('DOMContentLoaded', () => {
  smoothscroll.polyfill();
  Util.forEachPolyfill();
  Util.anchorsInit();

  new Menu();
  new ScrollEvent();

  new Tabs({
    tabs: '.js-tab a',
    content: '.js-tabcontent'
  });

  new Animation({ el: '.animation-reveal' });
});

window.onload = () => {
  document.body.classList.remove('loading');

  new Lazyload({ lazyimages: '.mainimage__background' });

  Sliders.pickupSlider();
  Sliders.shopimgSlider();
};
